import { memo } from 'react';
import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input as ChakraInput,
    InputGroup,
    InputRightElement,
    InputLeftElement,
    Box,
    Tooltip,
} from '@chakra-ui/react';

const Input = ({
    error,
    label,
    leftIcon,
    groupWidth,
    rightIcon,
    link,
    inputCursor,
    inputHover,
    iconHandler,
    inputProps,
    isSignUp,
    inputStyles,
    ...props
}) => {
    return (
        <FormControl w={groupWidth} isInvalid={!!error}>
            {label && (
                <FormLabel fontSize='sm' fontWeight='bold'>
                    {label}
                </FormLabel>
            )}

            <InputGroup cursor={inputCursor}>
                {leftIcon && <InputLeftElement>{leftIcon}</InputLeftElement>}

                <Tooltip
                    hasArrow
                    {...(isSignUp && error && { isOpen: true, label: error })}
                    {...(isSignUp && !error && { label: label })}
                    placement='top'
                >
                    <ChakraInput ref={link} _placeholder={{ fontSize: 'sm' }} px='3' {...inputProps} {...props} />
                </Tooltip>

                {rightIcon && (
                    <InputRightElement>
                        <Box cursor={iconHandler ? 'pointer' : 'auto'} onClick={iconHandler}>
                            {rightIcon}
                        </Box>
                    </InputRightElement>
                )}
            </InputGroup>

            {error && !isSignUp && (
                <FormErrorMessage color='red' fontSize='13px' mt='1'>
                    {error}
                </FormErrorMessage>
            )}
        </FormControl>
    );
};

export default memo(Input);
